import React, { useEffect } from "react";
import SelectOption from "../../../../../components/SelectOption";
import { useApi } from "../../../../../hooks/http2";
import _ from "lodash";

export default function SelectEvent({
  withAll,
  allText = "งานทั้งหมด",
  onLoaded,
  ...props
}) {
  const events = useApi(
    {
      baseURL: process.env.REACT_APP_EVENT_URL_API,
      url: `/events/active`,
    },
    []
  );

  useEffect(() => {
    if (events.fetch?.data?.length && typeof onLoaded === "function") {
      onLoaded(events.fetch.data); // sent to CriteriaTicket
    }
  }, [events.fetch]);

  const options = _.map(events.fetch?.data || [], (n) => ({
    ...n,
    value: n.Id,
    text: n.EventName,
  }));

  const finalOptions = withAll
    ? [{ value: "", text: allText }, ...options]
    : options;

  return (
    <SelectOption loading={events.loading} {...props} data={finalOptions} />
  );
}
